<!-- Mobile layout -->
<div
  class="flex flex-col gap-4 py-6 sm:flex-row sm:items-center sm:justify-between sm:gap-0"
>
  <!-- Items per page -->
  @if (config.showItemsPerPage) {
    <div class="flex items-center gap-2">
      <span class="text-base font-medium text-primary-text">Toon:</span>
      <select
        class="cursor-pointer bg-transparent text-base font-bold text-primary-text"
        [ngModel]="config.itemsPerPage"
        (ngModelChange)="onItemsPerPageChange(+$event)"
      >
        <option [ngValue]="10">10 items per pagina</option>
        <option [ngValue]="30">30 items per pagina</option>
        <option [ngValue]="50">50 items per pagina</option>
      </select>
    </div>
  }
  @if (!config.showItemsPerPage) {
    <div class="flex-1"></div>
  }

  <!-- Page numbers -->
  <nav
    class="flex w-full items-center justify-between sm:w-auto sm:justify-center"
    role="navigation"
    aria-label="Pagination"
  >
    <!-- First and Previous page group -->
    <div class="flex items-center gap-2">
      <!-- First page -->
      <button
        class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-lg leading-normal font-normal text-primary-text focus:ring-2 focus:ring-primary-border focus:outline-none disabled:opacity-50 sm:h-6 sm:w-6 sm:text-base"
        [disabled]="config.currentPage === 1"
        (click)="onPageChange(1)"
        (keydown.enter)="onPageChange(1)"
        (keydown.space)="onPageChange(1)"
        type="button"
        aria-label="Ga naar eerste pagina"
        tabindex="0"
      >
        «
      </button>

      <!-- Previous page -->
      <button
        class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-lg leading-normal font-normal text-primary-text focus:ring-2 focus:ring-primary-border focus:outline-none disabled:opacity-50 sm:h-6 sm:w-6 sm:text-base"
        [disabled]="config.currentPage === 1"
        (click)="onPageChange(config.currentPage - 1)"
        (keydown.enter)="onPageChange(config.currentPage - 1)"
        (keydown.space)="onPageChange(config.currentPage - 1)"
        type="button"
        aria-label="Ga naar vorige pagina"
        tabindex="0"
      >
        ‹
      </button>
    </div>

    <!-- Page numbers -->
    <div class="flex items-center gap-2">
      @for (
        item of getPageNumbers(config.totalPages, config.currentPage);
        track item
      ) {
        @if (item.type === 'ellipsis') {
          <span
            class="flex h-8 w-8 items-center justify-center rounded-full text-sm leading-normal font-normal text-primary-text sm:h-6 sm:w-6"
          >
            ...
          </span>
        }
        @if (item.type === 'page') {
          <button
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-sm leading-normal font-normal focus:ring-2 focus:ring-primary-border focus:outline-none sm:h-6 sm:w-6"
            [class.bg-primary-border]="item.value === config.currentPage"
            [class.text-primary-on]="item.value === config.currentPage"
            [class.bg-primary-background]="item.value !== config.currentPage"
            [class.text-primary-text]="item.value !== config.currentPage"
            [attr.aria-current]="
              item.value === config.currentPage ? 'page' : null
            "
            [attr.aria-label]="'Ga naar pagina ' + item.value"
            (click)="onPageChange(item.value)"
            (keydown.enter)="onPageChange(item.value)"
            (keydown.space)="onPageChange(item.value)"
            type="button"
            tabindex="0"
          >
            {{ item.value }}
          </button>
        }
      }
    </div>

    <!-- Next and Last page group -->
    <div class="flex items-center gap-2">
      <!-- Next page -->
      <button
        class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-lg leading-normal font-normal text-primary-text focus:ring-2 focus:ring-primary-border focus:outline-none disabled:opacity-50 sm:h-6 sm:w-6 sm:text-base"
        [disabled]="config.currentPage === config.totalPages"
        (click)="onPageChange(config.currentPage + 1)"
        (keydown.enter)="onPageChange(config.currentPage + 1)"
        (keydown.space)="onPageChange(config.currentPage + 1)"
        type="button"
        aria-label="Ga naar volgende pagina"
        tabindex="0"
      >
        ›
      </button>

      <!-- Last page -->
      <button
        class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-lg leading-normal font-normal text-primary-text focus:ring-2 focus:ring-primary-border focus:outline-none disabled:opacity-50 sm:h-6 sm:w-6 sm:text-base"
        [disabled]="config.currentPage === config.totalPages"
        (click)="onPageChange(config.totalPages)"
        (keydown.enter)="onPageChange(config.totalPages)"
        (keydown.space)="onPageChange(config.totalPages)"
        type="button"
        aria-label="Ga naar laatste pagina"
        tabindex="0"
      >
        »
      </button>
    </div>
  </nav>
</div>
